import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.85);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	width: 460px;
	padding: 30px;
	border-radius: 10px;
	background: #111314;
	box-shadow: 0px 6px 80px 0px rgba(0, 0, 0, 0.5);
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledModalHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledModalHeading = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;

	${Text} {
		color: #ffffff;
		font-size: 18px;
		font-weight: 700;
	}
`;

const StyledCloseButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		transition: filter 0.3s ease;
		pointer-events: none;
		user-select: none;
	}
`;

const StyledModalBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
`;

const StyledSaveInfoContainer = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	align-items: center;
	justify-content: space-between;
	row-gap: 10px;

	${Text} {
		color: #ffffff;
		font-size: 18px;
		font-weight: 500;

		&:nth-child(2n + 1) {
			opacity: 0.25;
		}

		&:nth-child(2n) {
			text-align: right;
		}
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
	margin-top: 30px;
`;

export {
	StyledModalWrapper,
	StyledContainer,
	StyledModalHead,
	StyledModalHeading,
	StyledCloseButtonContainer,
	StyledModalBody,
	StyledSaveInfoContainer,
	StyledButtonsContainer,
};
